/**
 * BB Option Pair — a later option only ever offers values that exist for the earlier ones.
 *
 * The Hog Track Kit sells the wire in-fill as an option, so "Wire Colour" is only meaningful
 * once there is an in-fill to colour. Left unconstrained the PDP happily lands on
 * "Mesh Opening = None (track only)" + "Wire Colour = Brown" — 63 of its 180 combinations have
 * no variant, and the price simply disappears.
 *
 * The first cut of this file repaired a bad selection after the fact and explained itself in a
 * note. That was wrong: choosing a track-only kit is a legitimate purchase, not a mistake, and
 * annotating it read as an error message for doing nothing wrong. So this constrains instead of
 * corrects — an invalid pairing is never reachable, and nothing needs explaining.
 *
 * Direction comes from Shopify's own option order, the same order the shopper reads: an option
 * is filtered by the options ABOVE it, never below. Track Size therefore always offers all nine
 * sizes and Mesh Opening always offers "None (track only)" — you can always get back to a bare
 * track. Wire Colour, being last, follows the opening: with a real opening it offers the three
 * colours; with "None (track only)" its only value is None, so the field is meaningless and
 * hides itself entirely.
 *
 * Derived from the variant JSON the section already prints, so nothing is hardcoded, and
 * self-disabling: a product whose matrix is complete never filters anything out.
 */
(function () {
  'use strict';

  var NONE = /^none\b/i;

  function init() {
    var jsonEl = document.querySelector('script[data-product-json]');
    if (!jsonEl) return;
    var data; try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var product = data.product || data;
    if (!product || !product.variants || !product.options) return;

    var names = (product.options || []).map(function (o) {
      return String(typeof o === 'string' ? o : (o.name || '')).toLowerCase();
    });
    if (names.length < 2) return;

    var combos = product.variants.map(function (v) {
      var row = [];
      for (var i = 0; i < names.length; i++) row.push(v['option' + (i + 1)]);
      return row;
    });

    // A complete matrix can never produce an invalid selection — leave the page alone.
    var full = 1;
    for (var n = 0; n < names.length; n++) {
      var seen = {};
      for (var c = 0; c < combos.length; c++) seen[combos[c][n]] = 1;
      full *= Object.keys(seen).length;
    }
    if (full === combos.length) return;

    var sels = Array.prototype.slice.call(
      document.querySelectorAll('select.single-option-selector[data-option-name]')
    );
    if (sels.length !== names.length) return;

    var bySlot = [];
    for (var s = 0; s < names.length; s++) {
      var want = names[s];
      var hit = sels.filter(function (el) {
        return String(el.dataset.optionName || '').toLowerCase() === want;
      })[0] || sels.filter(function (el) { return (el.dataset.index || '') === 'option' + (s + 1); })[0];
      if (!hit) return;
      bySlot.push(hit);
    }
    var wraps = bySlot.map(function (el) {
      return (el.closest && el.closest('.selector-wrapper')) || el.parentNode;
    });

    // Values of slot i that exist alongside the current choices in every slot above it.
    function allowed(i) {
      var out = [], seen = {};
      for (var c = 0; c < combos.length; c++) {
        var row = combos[c], ok = true;
        for (var j = 0; j < i; j++) {
          if (row[j] !== bySlot[j].value) { ok = false; break; }
        }
        if (ok && !seen[row[i]]) { seen[row[i]] = 1; out.push(row[i]); }
      }
      return out;
    }

    var busy = false;
    function apply() {
      if (busy) return;
      busy = true;
      for (var i = 0; i < bySlot.length; i++) {
        var el = bySlot[i], ok = allowed(i);
        if (!ok.length) continue;
        var lookup = {};
        for (var k = 0; k < ok.length; k++) lookup[ok[k]] = 1;

        for (var o = 0; o < el.options.length; o++) {
          var opt = el.options[o], live = !!lookup[opt.value];
          opt.hidden = !live;
          opt.disabled = !live;
          opt.style.display = live ? '' : 'none';
        }
        // Whatever is selected has to be one of the survivors.
        if (!lookup[el.value]) {
          el.value = ok[0];
          try { el.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {
            var ev = document.createEvent('HTMLEvents'); ev.initEvent('change', true, false); el.dispatchEvent(ev);
          }
        }
        // One value left and it means "not applicable" — the field has nothing to ask.
        var moot = ok.length === 1 && NONE.test(ok[0]);
        if (wraps[i]) wraps[i].style.display = moot ? 'none' : '';
      }
      busy = false;
    }

    bySlot.forEach(function (el) { el.addEventListener('change', apply); });
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
